import React, {ReactNode} from 'react';
import {Modal, Text} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';

export enum ConfirmationModalPrimaryButton {
	CONFIRM = 'CONFIRM',
	SAVE = 'SAVE',
}

type ConfirmationModalProps = {
	title: string;
	description: string | ReactNode;
	autoClosePositive: boolean;
	autoCloseNegative: boolean;
	callbackPositive: () => void;
	callbackNegative: () => void;
	closeModal: () => void;
	includeDefaultMessage: boolean;
	confirmationModalPrimaryButton: ConfirmationModalPrimaryButton;
};

const ConfirmCustomIdChangeModal = ({
	title,
	description,
	autoClosePositive = true,
	autoCloseNegative = true,
	callbackPositive,
	callbackNegative,
	closeModal,
	includeDefaultMessage = true,
	confirmationModalPrimaryButton = ConfirmationModalPrimaryButton.CONFIRM,
}: ConfirmationModalProps): JSX.Element => {
	const confirm = () => {
		callbackPositive();
		if (autoClosePositive) {
			closeModal();
		}
	};
	const cancel = () => {
		if (callbackNegative) {
			callbackNegative();
		}
		if (autoCloseNegative) {
			closeModal();
		}
	};
	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>{title}</Modal.Title>
			<Modal.Content>
				{typeof description === 'string' ? <Text>{description}</Text> : description}

				{includeDefaultMessage && (
					<Text>
						<FormattedMessage id="common.are_you_sure_proceed" />
					</Text>
				)}
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={confirm} dataCy="confirmation-modal-primary-button">
					{confirmationModalPrimaryButton === ConfirmationModalPrimaryButton.SAVE ? (
						<FormattedMessage id="common.save" />
					) : (
						<FormattedMessage id="common.confirm" />
					)}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={cancel} dataCy="confirmation-modal-secondary-button">
					<FormattedMessage id={'common.cancel'} />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmCustomIdChangeModal;
